import React from "react";

// Official InaTeB logo (wordmark + gear/circuit mark + tagline) as transparent PNG.
export const Logo = ({ className = "", height = 44 }) => {
  return (
    <img
      src="/inateb-logo.png"
      alt="InaTeB – Industrieanlagenservice & Anlagentechnik"
      data-testid="brand-logo"
      className={`block w-auto select-none ${className}`}
      style={{ height }}
      draggable={false}
    />
  );
};

export default Logo;
